app.directive('question', ['LocaleService', 'constants', '$ionicPopup',
    function (LocaleService, Constants, $ionicPopup) {
        return {
            scope: {
                question: '<',
                control: '=',
                viewOnly: '<'
            },
            restrict: 'E',
            templateUrl: 'templates/directives/question.html',
            link: function (scope, element) {
                scope.translation = LocaleService.translation;
                scope.showOther = scope.question.other.length > 0;
                scope.tmp = {
                    value: scope.viewOnly ? scope.question.values.id : ''
                };

                //set validate function of the directive to the control object
                scope.control[scope.question.id] = {};
                scope.control[scope.question.id].validate = function () {
                    return scope.validate();
                };

                scope.updateModel = function () {
                    if(scope.viewOnly) {
                        return;
                    }

                    //TODO - multiselect
                    scope.question.values = scope.question.formatAnswer(scope.tmp.value);

                    if (scope.question.allowOther) {
                        scope.showOther = scope.isOther();
                    }

                    //trigger popup on specific answers
                    if (Constants['questionnairePopups'] && Constants['questionnairePopups'][scope.tmp.value]) {
                        var popupTranslationKey = Constants['questionnairePopups'][scope.tmp.value];
                        scope.showPopup('', scope.translation[popupTranslationKey]);
                    }
                };

                scope.isOther = function () {
                    if (scope.question.isMulti) {
                        return Array.isArray(scope.question.values) && !!_.find(scope.question.values, {id: '-1'});
                    }
                    return scope.question.values['id'] == "-1";
                };

                scope.showPopup = function (title, body) {
                    var buttons = [];
                    if (!!Constants.questionnaireResetAnswerButton) {
                        buttons.push({
                            text: LocaleService.translation.close,
                            onTap: function (e) {
                                e.preventDefault();
                                scope.tmp.value = '';
                                scope.updateModel();
                                myPopup.close();
                            }
                        });
                    }
                    buttons.push({
                        text: !!Constants.questionnaireResetAnswerButton ? LocaleService.translation.i_understand : LocaleService.translation.continue,
                        type: 'button-positive',
                        onTap: function (e) {
                            e.preventDefault();
                            myPopup.close();
                        }
                    });

                    var myPopup = $ionicPopup.show({
                        template: body,
                        title: title || 'Warning',
                        scope: scope,
                        buttons: buttons
                    });
                };

                scope.validateForm = function () {
                    if (this.form.other) {
                        this.form.other.$setTouched();
                        this.form.other.$setDirty();
                    }
                };

                scope.validate = function () {
                    scope.validateForm();

                    scope.question.valid = false;

                    //if "other" is permitted
                    if (scope.question.allowOther) {
                        var isOther = scope.question.onlyOther || scope.isOther();

                        //reset other value if no "other" is selected
                        if (scope.question.allowOther && !isOther) {
                            scope.question.other = ""
                        }

                        if (isOther && scope.question.other && scope.question.other.length > 0) {
                            scope.question.valid = true;
                        }

                        if (!isOther && scope.question.values && Array.isArray(scope.question.values) && scope.question.values.length > 0) {
                            scope.question.valid = true;
                        }

                        if (!isOther && scope.question.values && !scope.question.isMulti) {
                            scope.question.valid = true;
                        }
                    } else {
                        if (scope.question.values && Array.isArray(scope.question.values) && scope.question.values.length > 0) {
                            scope.question.valid = true;
                        }
                        if (scope.question.values && !Array.isArray(scope.question.values)) {
                            scope.question.valid = true;
                        }
                    }
                    return scope.question.valid;
                };

                element.on('$destroy', function () {
                    //remove validate function from control object
                    delete scope.control[scope.question.id];
                });
            }
        }
    }]);
